import { useTranslation } from "react-i18next"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import type { TypographyProps } from "@mui/material"

import type { SeasonAmpacity } from "types/ampacity.types"
import { formatSeasonalAmpacityLines } from "helpers/utils/seasonalAmpacity"

interface SeasonalAmpacityBreakdownProps {
  seasonal: SeasonAmpacity
  entryProps?: TypographyProps
}

/**
 * Renders the seasonal ampacity dictionary as a vertical breakdown, one line per
 * season showing its validity window and value ("Jun 1 – Oct 1: 800 A").
 */
const SeasonalAmpacityBreakdown = ({
  seasonal,
  entryProps,
}: SeasonalAmpacityBreakdownProps) => {
  const { i18n } = useTranslation()

  return (
    <Stack>
      {formatSeasonalAmpacityLines(seasonal, i18n.resolvedLanguage).map((line) => (
        <Typography key={line} {...entryProps}>
          {line}
        </Typography>
      ))}
    </Stack>
  )
}

export default SeasonalAmpacityBreakdown
